/**
 * Service de gestion des gares de transport
 * Centralise tous les appels API liés aux gares
 */
import apiService from './api.service';

class StationService {
  /**
   * Créer une nouvelle gare
   */
  async createStation(stationData) {
    return await apiService.post('compagnieTransport', stationData);
  }

  /**
   * Obtenir la liste des demandes d'adhésions validées
   */
  async getValidatedAdhesions() {
    return await apiService.get('demandeAdhesion/demandesValidees');
  }

  /**
   * Récupérer la liste des gares par compagnie
   * Note: L'API utilise POST au lieu de GET
   */
  async getStationsByCompany(companyName) {
    const response = await apiService.postForGet('gares/getGareByCompagnieTransportRaisonScoiale', {
      data: {
        compagnieTransportRaisonSociale: companyName
      }
    });
    return response.items || [];
  }

  /**
   * Mettre à jour une gare
   */
  async updateStation(stationId, stationData) {
    return await apiService.put(`gareCompagnieTransport/${stationId}`, stationData);
  }

  /**
   * Supprimer une gare
   */
  async deleteStation(stationId) {
    return await apiService.delete(`gareCompagnieTransport/${stationId}`);
  }

  /**
   * Obtenir les détails d'une gare
   */
  async getStationDetails(stationId) {
    return await apiService.get(`gareCompagnieTransport/${stationId}`);
  }
}

export default new StationService();
